<template>
	<div>
		<img ref="image" :width="settings.width" :height="settings.height" :class="settings.class" />
	</div>
</template>
<script>
	import _ from 'lodash'
	import DEFAULTPERSONIMAGE from '../../assets/person.svg'
	import DEFAULTPERSONIMAGE2 from '../../assets/person2.png'
	import DEFAULTPRODUCTIMAGE from '../../assets/Avatars/Product.svg'
	import DEFAULTCOMPANYIMAGE from '../../assets/company.png'
	export default {
		props: ['modelValue', 'options'],
		data() {
			return {
				settings: {
					width: 'auto',
					height: 'auto',
					class: '',
					defaultImage: ''
				}
			}
		},
		created() {
			if (this.params?.options) this.settings = _.merge(this.settings, this.params.options)
		},
		mounted() {
			this.prepare(this.modelValue)
		},
		computed: {

		},
		watch: {
			modelValue: {
				deep: true,
				immediate: true,
				handler(val, oldVal) {
					this.prepare(val)
				}
			},
			options: {
				immediate: true,
				deep: true,
				handler(val, oldVal) {
					this.settings = _.extend({}, this.settings, val)
				}
			}
		},
		methods: {
			prepare(val) {
				if (!this.$refs.image)
					return

				if (val) {
					$(this.$refs.image).attr('src', val)
					return
				}

				if (this.settings.defaultImage) {
					switch (this.settings.defaultImage) {
						case 'person':
							$(this.$refs.image).attr('src', DEFAULTPERSONIMAGE)
							break

						case 'person2':
							$(this.$refs.image).attr('src', DEFAULTPERSONIMAGE2)
							break

						case 'product':
							$(this.$refs.image).attr('src', DEFAULTPRODUCTIMAGE)
							break

						case 'company':
							$(this.$refs.image).attr('src', DEFAULTCOMPANYIMAGE)
							break

						default:
							$(this.$refs.image).attr('src', DEFAULTPERSONIMAGE)
					}
				}
			}
		}
	}
</script>
